@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.searchInput {
  @include md-regular;
  cursor: pointer;
  background-color: transparent;
  text-align: center;
  width: 100%;
}

.fontSize {
  justify-content: flex-start;
  padding: 8px;
  border-radius: 4px !important;

  &:hover {
    background: var(--dark-4);

    [data-autopilot-system-redesign='on'] & {
      &.selected {
        background: var(--dark-80);
        color: var(--light-100);
      }
    }
  }
}
